import {createFileRoute} from "@tanstack/react-router";
import {ErrorComponent} from "./-errorComponent";
import {NotFoundComponent} from "./-notFoundComponent";
import {PendingComponent} from "./-pendingComponent";
import {RouteComponent} from "./-routeComponent";
import {getProductInventoriesWithCaching} from "~/utilities/queries";

export const Route = createFileRoute("/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/w/$workspaceId/_defaultScaffold/product-inventories")({
    loader: async ({context}) => {
        const productInventoriesResult = await getProductInventoriesWithCaching({
            workspaceId: context.workspace.id,
            intellsysBaseUrl: context.intellsysBaseUrl,
            accessToken: context.authenticationStatus.accessToken,
            queryClient: context.queryClient,
        });

        if (productInventoriesResult.success !== true) {
            throw new Error("Failed to fetch product inventories");
        }

        return {
            productInventories: productInventoriesResult.data,
        };
    },
    component: RouteComponent,
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});
